export function WildernessLogo() {
	return (
		<div className="flex flex-row gap-1">
			<h1 className="text-2xl">🌲</h1>
			<h1 className="text-2xl text-white font-semibold">wilderness</h1>
		</div>
	);
}
